/**
 * Formata uma data para exibição no formato brasileiro
 * @param {string} dateString - String de data no formato ISO
 * @param {boolean} includeTime - Se deve incluir horas e minutos
 * @returns {string} Data formatada
 */
export const formatDate = (dateString, includeTime = false) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  if (isNaN(date.getTime())) {
    return '';
  }
  
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };
  
  if (includeTime) {
    options.hour = '2-digit';
    options.minute = '2-digit';
  }
  
  return date.toLocaleDateString('pt-BR', options);
};

/**
 * Formata um valor monetário
 * @param {number} value - Valor a ser formatado
 * @returns {string} Valor formatado como moeda brasileira
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined) return '';
  
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

/**
 * Formata um número de telefone brasileiro
 * @param {string} phone - Número de telefone
 * @returns {string} Telefone formatado
 */
export const formatPhone = (phone) => {
  if (!phone) return '';
  
  // Remove tudo que não for número
  const cleaned = phone.replace(/\D/g, '');
  
  // Verifica o formato
  if (cleaned.length === 11) {
    // Formato com 9 dígitos (celular)
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
  } else if (cleaned.length === 10) {
    // Formato com 8 dígitos (fixo)
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
  }
  
  // Se não estiver em um formato conhecido, retorna como está
  return phone;
}; 